import { createContext } from 'react';

import {
  UbiquitiApiDataItem,
  UbiquitiConnectedClient,
} from '@totem/components/ubiquiti/types';

interface Context {
  loading: boolean;
  error: boolean;
  clients: UbiquitiApiDataItem<UbiquitiConnectedClient>[];
}

export default createContext<Context>({
  loading: false,
  error: false,
  clients: [],
});
